const LongArrowRitght = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.485 4.94238L18.3184 10.7757M18.3184 10.7757L12.485 16.6091M18.3184 10.7757L3.31836 10.7757"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default LongArrowRitght
